import __C from '../../../../../../includes/primitives/_constant_'

export default {
    Canvas: {
      CanvasWidth: 350,
      CanvasHeight: 230,
      CanvasBorderWeight: 0.1,
      CanvasBorderColor: '#bcbcbc',
      CanvasFillColor: 'Transparent',
      CanvasOpacity: 0.2,

      CanvasChartX: 0,
      CanvasChartY: 0,
      CanvasChartWidth: 1300,
      CanvasChartHeight: 760,
      CanvasChartBorderWeight: 0,
      CanvasChartBorderColor: '#757575',
      CanvasChartFillColor: '#757575',
      CanvasChartOpacity: 0,
      CanvasChartSpace: 0,

      CanvasFontFamily: 'roboto',
    },

    
  Text: {
    Text: [],
    Filter: [],
    Sql: [
      {
        query: "SELECT 'Data source : '+ [TITLE] + [WEEK_NO] text FROM [T01_Project].[DataSource].[Document] WHERE [PHASE] = 'PLANNING' AND [CODE] = 'HISTOGRAM'", 
        text: 'DataSource',
        x: 320,
        y: 0,
        font: 'roboto',
        style: 'regular',
        size: 10,
        color: '#757575',
        align: 'start'
      },
    ]
  },

    DataItems: [
      { PLAN: 27.01, ACTUAL: 18.45, DELTA: -8.56, },
    ],
}